import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
import { SlackIntegrationGraph } from '../components/SlackIntegrationGraph';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4433" />
      {/* <NovaSection /> Hidden per user request */}
      <SlackIntegrationGraph data-id="element-4434" />
      {/* "How it works" / Plug-and-play moved above the Giga for You / Team
                  audience switch per the intended narrative flow. */}
      <GettingStartedSteps data-id="element-4435" />
      <AudienceSwitch data-id="element-4436" />
      {/* <LivesInSlack /> Hidden from home for now — kept for reuse on another page later */}
      {/* Capability grid ("Built to do the work…") leads, then the
              "Giga brings its own computer" proof beat — which stays ahead of the
              reviews (WallOfLove) below. */}
      <CapabilityGrid data-id="element-4437" />
      <ComputerUse data-id="element-4438" />
      <NarrativeSection data-id="element-4439" />
      <ToolComparison data-id="element-4440" />
      <WallOfLove data-id="element-4441" />
      {/* <PricingSection /> Hidden from home for now — still a waitlist. Kept
              for reuse; bring back when pricing goes live. */}
      <ClosingCTA data-id="element-4442" />
    </>;
}